// Unpublished Work © 2021-2022 Deere & Company

import * as actions from '../../action-list';
import {SearchPreferences} from '../../state/struct/customer-search/facets/search-preferences';

const savePreferences = (state, action) =>
    SearchPreferences.update(state, {
        $set: action.searchPreferences
    });

export const savedSearchPreferences = (state = SearchPreferences({}), action = {}) => {
    const actionHandlers = {
        [actions.SET_SEARCH_PREFERENCES]: savePreferences,
        [actions.UPDATE_SEARCH_PREFERENCES_AFTER_SAVE]: savePreferences
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
